import { GreenCircleCheckmark } from '../../../../svg/GreenCircleCheckmark';
import FlexibleLink from '../../../../util/FlexibleLink';

const DeclinedIntroductionModalContent = () => {
  return (
    <div className={'flex flex-col gap-4 p-6 text-center items-center justify-center'}>
      <GreenCircleCheckmark />
      <div className='font-semibold'>Thanks for your feedback!</div>
      <div>
        Questions or concerns about finding a match?{' '}
        <FlexibleLink
          className={'text-brand-600'}
          href={'mailto:match@movingworlds.org'}
          type='external'
        >
          Send us a message
        </FlexibleLink>{' '}
        and a real person from our team will follow up with you.
      </div>
    </div>
  );
};

export default DeclinedIntroductionModalContent;
